export { default } from './CarrosEletricosBannerMoveBrasil';
